import { styled } from "@mui/material";
import MuiAppBar from '@mui/material/AppBar';
export default styled(MuiAppBar, {
    shouldForwardProp: function (prop) { return prop !== 'open'; },
})(function (_a) {
    var _b;
    var theme = _a.theme;
    return ({
        boxShadow: 'inherit',
        borderBottom: "1px solid ".concat((_b = theme === null || theme === void 0 ? void 0 : theme.palette) === null || _b === void 0 ? void 0 : _b.divider),
        backgroundColor: theme === null || theme === void 0 ? void 0 : theme.palette.background.default,
        zIndex: theme.zIndex.drawer + 1,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        })
    });
});
